import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class EmployeeFunctionGroupsDbTableDefinition extends DbTableDefinition {
  tableName = 'employeeFunctionGroups';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
     employeeid BIGINT(20),
     functiongroupid BIGINT(20),
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(62, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
